import { render, staticRenderFns } from "./slGroups.vue?vue&type=template&id=14067518"
import script from "./slGroups.vue?vue&type=script&lang=js"
export * from "./slGroups.vue?vue&type=script&lang=js"
import style0 from "./slGroups.vue?vue&type=style&index=0&id=14067518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports